
<ng-container *ngIf="headFootVisible">
    <app-navbar [importantUpdatesValue]="importantUpdates" (toggleImportantUpdates)="toggleDrawer()" (getImportantUpdates)="getImportantUpdates($event)"></app-navbar>
</ng-container>
<div class="main-content" [ngClass]="{'p-0': !headFootVisible}">
    <router-outlet></router-outlet>
</div>
<ng-container *ngIf="importantUpdates?.length">
    <div class="drawer"  [@drawerState]="drawerOpen ? 'open' : 'closed'">
        <app-important-updates [updates]="importantUpdates" (closeDrawer)="toggleDrawer()"></app-important-updates>
    </div>
</ng-container>
<div class="important-update-overlay" [ngClass]="drawerOpen ? 'open' : 'closed'" (click)="drawerOpen = !drawerOpen"></div>
<ng-container *ngIf="headFootVisible">
    <app-footer></app-footer>
</ng-container>

<app-scroll-top></app-scroll-top>
<download-mobile-app></download-mobile-app>
